var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart08-template',{attrs:{"board-ids":[292, 293, 597, 396, 586, 607],"data-type":_vm.dataType,"graph-id":88,"title":"근골격계 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }